import styled from "styled-components";

export const Title = styled.h1`
  position: absolute;
  font-family: "DM Serif Display", serif;
  font-weight: 500;
  font-size: 32px;
  color: white;
  visibility: hidden;
  opacity: 1;
  z-index: 4;
`;
